import { SystemIcon } from '@helpers/icons';
import { clamp, tabIndexHTML } from '@helpers/utils';
import Button, { LinkButton } from '@stories/Components/Buttons/Button/Button';
import Accordion from '@stories/Components/Misc/Accordion/Accordion';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './Faqs.styles';
const Faqs = (props) => {
    const [active, setActive] = React.useState(0);
    const [showAll, setShowAll] = React.useState(false);
    const tabRef = React.useRef([]);
    React.useEffect(() => {
        setShowAll(false);
    }, [active]);
    if (!props.categories || props.categories.length === 0) {
        return null;
    }
    function getCtaColour(theme) {
        switch (theme) {
            case ContentType.Savings:
                return 'savings';
            case ContentType.Intermediaries:
                return 'intermediaries';
            case ContentType.Default:
            default:
                return 'default';
        }
    }
    function getFAQTheme(theme, categoryTheme) {
        if (theme.includes('light')) {
            if (categoryTheme === ContentType.Savings) {
                return 'light-blue';
            }
            return 'light-green';
        }
        if (categoryTheme === ContentType.Savings) {
            return 'blue';
        }
        return 'green';
    }
    return (React.createElement(S.Container, { id: props.id, "data-theme": getFAQTheme(props.theme ?? 'blue', props.categories[active]?.theme ?? ContentType.Default), translations: props.translations },
        React.createElement(S.Inner, null,
            React.createElement(S.Controls, null,
                props.subTitle && React.createElement(S.SubTitle, null, props.subTitle),
                props.title && React.createElement(S.Heading, null, props.title),
                React.createElement(S.Tabs, { role: "tablist", "data-hidden": props.categories.length === 1, "aria-labelledby": `${props.id}-faq-tab-label` }, props.categories.map((category, i) => (React.createElement(Button, { key: `${category.id}-button`, id: category.id, ref: (el) => (tabRef.current[i] = el), buttonType: "default", role: "tab", "aria-selected": active === i, "data-icon-theme": category.theme, "data-parent-theme": props.theme, onClick: () => {
                        if (active !== i) {
                            setActive(i);
                        }
                    }, onFocus: () => setActive(i), tabIndex: props.categories.length === 1 || active !== i ? -1 : undefined, onKeyDown: (event) => {
                        const nextIndex = i === props.categories.length - 1
                            ? 0
                            : clamp(i + 1, props.categories.length - 1);
                        const prevIndex = i === 0
                            ? props.categories.length - 1
                            : clamp(i - 1, props.categories.length - 1);
                        switch (event.key) {
                            case 'ArrowRight':
                            case 'ArrowDown':
                                event.preventDefault();
                                event.stopPropagation();
                                tabRef.current[nextIndex]?.focus();
                                break;
                            case 'ArrowLeft':
                            case 'ArrowUp':
                                event.preventDefault();
                                event.stopPropagation();
                                tabRef.current[prevIndex]?.focus();
                                break;
                            case 'Home':
                                tabRef.current[0]?.focus();
                                break;
                            case 'End':
                                tabRef.current[props.categories.length - 1]?.focus();
                                break;
                            default:
                                break;
                        }
                    }, iconPosition: "left", icon: category.icon ?? SystemIcon.House }, category.title))))),
            React.createElement(S.FaqGroups, null, props.categories.map((category, i) => (React.createElement(S.AccordionWrapper, { key: category.id, role: "tabpanel", "aria-labelledby": category.id, "data-active": active === i },
                React.createElement(Accordion, null, category.faqs.slice(0, 7).map((faq) => (React.createElement(Accordion.Item, { key: faq.id, id: faq.id, title: faq.question },
                    React.createElement(S.FaqContent, null,
                        React.createElement(S.Answer, { dangerouslySetInnerHTML: { __html: tabIndexHTML(faq.answer, active === i) } }),
                        faq.ctas && (React.createElement(S.ButtonWrapper, null, faq.ctas.map((cta, j) => (React.createElement(LinkButton, { key: `${faq.id}-cta-${j}`, buttonType: getCtaColour(category.theme ?? ContentType.Default), href: cta.url, target: cta.target, icon: cta.icon, tabIndex: active === i ? undefined : -1 }, cta.text)))))))))),
                category.faqs.length > 7 ? (React.createElement(S.ExtraFaqs, { "data-show-extra": showAll },
                    React.createElement(Accordion, null, category.faqs.slice(7).map((faq) => (React.createElement(Accordion.Item, { key: faq.id, id: faq.id, title: faq.question },
                        React.createElement(S.FaqContent, null,
                            React.createElement(S.Answer, { dangerouslySetInnerHTML: {
                                    __html: tabIndexHTML(faq.answer, active === i && showAll),
                                } }),
                            faq.ctas && (React.createElement(S.ButtonWrapper, null, faq.ctas.map((cta, j) => (React.createElement(LinkButton, { key: `${faq.id}-cta-${j}`, buttonType: getCtaColour(category.theme ?? ContentType.Default), href: cta.url, target: cta.target, icon: cta.icon, tabIndex: active === i && showAll ? undefined : -1 }, cta.text)))))))))))) : null,
                category.faqs.length > 7 && !showAll && (React.createElement(S.ButtonWrapper, null,
                    React.createElement(Button, { buttonType: getCtaColour(category.theme ?? ContentType.Default), onClick: () => setShowAll(true), tabIndex: active === i ? undefined : -1, icon: SystemIcon.ArrowDown }, props.translations?.['global.faq.viewmore']))))))))));
};
export default Faqs;
